const yellowHue = 49;
const blueHue = yellowHue + 180;

export const bodyBackgroundColor = `hsla(${yellowHue}, 100%, 66%, 1)`;
export const bodyTextColor = `hsla(${blueHue}, 20%, 20%, 1)`;
export const headingTextColor = `hsla(${blueHue}, 40%, 10%, 1)`;
export const linkColor = `hsla(${blueHue}, 80%, 50%, 1)`;
export const linkHoverActiveColor = `hsla(${blueHue}, 100%, 59%, 1)`;



// WEBPACK FOOTER //
// ./src/utils/colors.js